import './style/index.scss';
import * as ReactDOMClient from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import React from 'react';
import App from './App';

if ('serviceWorker' in navigator) {
  (async () => {
    try {
      const registration = await navigator.serviceWorker.register('./service-worker.js');
      await registration.update();
      // console.log("SW registered: ", registration);
      (window as any).__JSDC_SW__ = registration;
      ReactDOMClient.createRoot(document.getElementById('root') as Element).render(<App />);

      reportWebVitals();
    } catch (registrationError) {
      console.log('SW registration failed: ', registrationError);
    }
  })();
}
